import axios from 'axios'
import { genURL } from "../../_getjson";

export default async function Chackdocgroup(code, tablename) {
    if (code) {
        let rs = ""
        let Url = "CSDOCMAX/Getdocmax?tablename=" + tablename + "&code=" + code;
        // console.log("Chackdocgroup", Url);
        await axios.get(genURL(Url), { timeout: 6000 }).then((res) => {

            rs = res.data["maxdoc"]
        }).catch((err) => {
            // console.log(err);
        });
        return rs
    }
};